import React, {Component, PureComponent} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, Image
} from "react-native";
import styles from "../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../customviews/empty/EmptyView";
import Colors from "../../../tools/Colors";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import {typeExport} from "../../../redux/store/type";
import store from "../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError
} from "./action/ActionListUserChatScreen";
import {moderateScale} from "../../../tools/Scaling";
import HMTextView from "../../../customviews/HMTextView";
import HMTextInput from "../../../customviews/HMTextInput";
//import HMModal from "../../../customviews/HMModal";
import * as NavigationService from "../../../redux/NavigationService";
import HMButton from "../../../customviews/HMButton";
import HMIcon from "../../../customviews/HMIcon";
import PathFile from "../../../assets/PathFile";
import importFirebase from "../../../importCalss/firebase/importFirebase";
import HMAlert from "../../../customviews/HMAlert";
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";
import HMRecycleView from "../../../customviews/HMRecycleView";


let container = null;

let firebase = importFirebase;
let recyclerlistview = Platform.select({
    web: () => require('recyclerlistview/web'),
    android: () => require('recyclerlistview'),
    ios: () => require('recyclerlistview')
})();

const {RecyclerListView, DataProvider, LayoutProvider} = recyclerlistview;

let textInputSearch = null;
export default class ListUserChatScreen extends PureComponent {
    constructor(props) {
        super(props);
     //   global._refreshListOpertor = true;


        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }
        this.state = {
            canChangeSize: false,
            dataProvider: new DataProvider((r1, r2) => {
                return r1 !== r2;
            }),
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    let columnWidth = viewportWidth;
                    switch (type) {
                        case 'VSEL':
                            dim.width = columnWidth;
                            dim.height = 80;
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),

            listSearch: null,
            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,


            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            textInputSearch: null

        };
        container = this;


        this.props.navigation.addListener('focus', () => {
                if (global._refreshListOpertor) {
                    store.dispatch(serviceActionListFilter([]))
                    props.callserviceActionRefresh();
                    this.getData(1)
                    global._refreshListOpertor = false
                }

            }
        )
        this.props.navigation.addListener('blur', () => {
            }
        )

    }

    state = {
        show: false
    };

    /*

        shouldComponentUpdate(nextProps, nextState) {
            //console.log('[Persons.js] shouldComponentUpdate',nextState.textInputSearch,this.state.textInputSearch);

            // if (nextState.textInputSearch !== this.state.textInputSearch) {
            //     console.log('shouldComponentUpdate',nextState.textInputSearch,this.state.textInputSearch);
            //
            //     return false;
            // } else {
            //     return true;
            // }
        }
    */

    componentWillReceiveProps(props) {

        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {
                    if (firebase)
                        this.goDetailsOpenNotif()

                }
            )
            :
            null
    }

    /*    async componentDidMount() {

            const channel = new firebase.notifications.Android.Channel(
                'channelId',
                'Channel Name',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }

                if (notification && notification.data && notification.data.typeOperation === '1') {
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });
        }*/

    async componentDidMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })
        this.setState({
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    const columnWidth = this.state.viewportWidth;
                    switch (type) {
                        case 'VSEL':
                            dim.width = columnWidth;
                            dim.height = 80;
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),
        })
        // await DeviceInfo.getMacAddress().then(mac => {
        //     //alert(mac)
        //     MAC_ADDRESS = mac
        // });
        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)


        if (firebase) {
            const channel = new firebase.notifications.Android.Channel(
                '1',
                'A',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                //  alert("yyyy")
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setLargeIcon('logo') // create this icon in Android Studio

                        //  .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error("error_notifications", err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }


                if (notification && notification.data && notification.data.typeOperation === '1') {
                    if (item.length > 0) {
                        global.list_menu_shahrdar = item;
                        this.setState({alaki: !this.state.alaki})

                    }
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });


            this.notificationOpenedListener = await firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
                // Get the action triggered by the notification being opened
                const action = notificationOpen.action;
                // Get information about the notification that was opened
                const notification: Notification = notificationOpen.notification;
                let item = null
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                try {
                    firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                    switch (notificationOpen.notification.data.typeOperation) {
                        //looking for
                        case "1":
                            if (item) {
                                // if (this.props.result && this.props.result > 0) {
                                //     let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                                //     if (idx === -1) {
                                //         store.dispatch(serviceActionListFilter([]))
                                //         this.props.callserviceActionRefresh();
                                //         this.getData(1)
                                //     }
                                //
                                // }
                                //  NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                    index: 0,
                                    item: item,
                                })
                            }

                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        // case "1":
                        //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //     NavigationService.navigateParams("MessagesSell", {type: 1});
                        //     break;
                        default:

                    }

                }
                catch (e) {

                }

            });

        }


        // let myLocation = store.getState().reducerSplashGetAllData.Location;
        // myLocation ? this.sendLocation(myLocation.coords) : null;

    }

    async goDetailsOpenNotif() {
        const notificationOpen = await firebase.notifications().getInitialNotification();
        let item = null

        if (notificationOpen) {
            if (notificationOpen.notification.data.item)
                item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
            firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)
            try {
                switch (notificationOpen.notification.data.typeOperation) {
                    //looking for
                    case "2":
                        if (item)
                            NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                index: 0,
                                item: item,
                            })
                        // NavigationService.navigatereset("MessagesBuy", {type: 1});
                        //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                        break;

                    case "1":
                        // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //NavigationService.navigateParams("MessagesSell", {type: 1});
                        break;
                    default:

                }

            }
            catch (e) {

            }
        }
    }

    componentWillUnmount() {
        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
            this.notificationOpenedListener();

        }
    }

    async getData(page) {
        let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListUserChatScreen, `?type=${this.props.typee}&Condition=`, TypeGetListUserChatScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListUserChatScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListUserChatScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListUserChatScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": "GetContacts",
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashGetAllData.token,
            "page": page,
            "type": null,
            "listFilter": this.state.arraySelected,
            // "textInputSearch": this.state.textInputSearch,
            "textInputSearch": textInputSearch,

            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetListUserChatScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {extraData, data} = this.props.route && this.props.route.params ? this.props.route.params : {};

        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let {TypeLogin, resultsShahrdar, results} = store.getState().reducerSplashGetAllData;
        // let checkClick = (TypeLogin === 2 ? resultsShahrdar : results)
        let checkClick = (TypeLogin === 2 ? resultsShahrdar : results)
        // let childFilter = result.items[this.state.indexFilter].list;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        let heightSlider = moderateScale(80);
        let widthSlider = this.state.viewportWidth - moderateScale(Platform.OS === "web" ? 30 : 4);


        console.log("this.state.listSearch", this.state.listSearch)
        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            // menu
                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListOperatorApply.title')}
                            text={"لیست کاربران"}
                            //   text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}
                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListUserChatScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>
                            {/*  <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput value={this.state.textInputSearch}
                                                     onChangeText={(text) => this.setState({textInputSearch: text}, () => {
                                                         //  this.getJsonMap()

                                                     })}
                                                     _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                                     placeholder={i18n.t('constant.textInputSearch')}
                                                     NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                                     style={{
                                                         fontSize: moderateScale(11),

                                                         // marginTop: moderateScale(6)
                                                     }} underlineColorAndroid="transparent"/>
                                    </View>
                                    {
                                    this.state.loadingAddressMarker ?
                                    <ActivityIndicator color={Colors.colorPrimary}
                                    size={"large"}/>

                                    :
                                    <HMTextView
                                    numberOfLines={1}
                                    onPress={() => HMAlert(
                                    i18n.t('constant.address'),
                                    this.state.addressMap,
                                    [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                    {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                    }
                                    },
                                    ],
                                    {cancelable: true}
                                    )}
                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                    text={this.state.addressMap}
                                    type={"bold"} style={{
                                    //textAlign: "center",
                                    color: Colors.gray,
                                    fontSize: moderateScale(11),
                                    marginEnd: moderateScale(3)


                                    // flex:1
                                    }}/>
                                    }

                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.getData(1)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(11)

                                        }}/>
                                </TouchableOpacity>

                            </View>*/}
                            <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput
                                            _ref={(ref) => {
                                                this.refInputTextComment = ref

                                            }}

                                            // value={textInputSearch}
                                            onChangeText={(text) => {
                                                textInputSearch = text;
                                                if (text === null || text.length === 0) {
                                                    this.setState({
                                                        listSearch: null
                                                    })
                                                }
                                                // this.setState({textInputSearch: text}, () => {
                                                //
                                                //     if (text === null || text.length === 0) {
                                                //         this.setState({
                                                //             listSearch: null
                                                //         })
                                                //     }
                                                // })
                                            }
                                            }
                                            _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                            placeholder={"جستجو نمایید"}
                                            NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                            style={{
                                                fontSize: moderateScale(11),

                                                // marginTop: moderateScale(6)
                                            }}
                                            onSubmitEditing={() => {
                                                this.SearchFilterFunction(this.props.results, textInputSearch)
                                            }}
                                            underlineColorAndroid="transparent"/>
                                    </View>
                                    {
                                        this.state.loadingAddressMarker ?
                                            <ActivityIndicator color={Colors.colorPrimary}
                                                               size={"large"}/>

                                            :
                                            <HMTextView
                                                numberOfLines={1}
                                                onPress={() => HMAlert(
                                                    i18n.t('constant.address'),
                                                    this.state.addressMap,
                                                    [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )}
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={this.state.addressMap}
                                                type={"bold"} style={{
                                                //textAlign: "center",
                                                color: Colors.gray,
                                                fontSize: moderateScale(11),
                                                marginEnd: moderateScale(3)


                                                // flex:1
                                            }}/>
                                    }

                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.SearchFilterFunction(this.props.results, textInputSearch)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(11)

                                        }}/>
                                </TouchableOpacity>

                            </View>

                            <EmptyView
                                empty={this.state.listSearch === null ? this.props.empty : (this.state.listSearch && this.state.listSearch.length === 0)}/>

                            {this.props.results && this.props.results.length > 0 ? (
                                <HMRecycleView
                                    style={{flex: 1}}
                                    contentContainerStyle={{margin: 3}}
                                    //onEndReached={this.handleLoadMore.bind(this)}
                                    dataProvider={this.state.dataProvider.cloneWithRows(this.state.listSearch === null ? this.props.results : (this.state.listSearch))}
                                    layoutProvider={this.state.layoutProvider}
                                    renderAheadOffset={0}
                                    canChangeSize={this.state.canChangeSize}
                                    //  forceNonDeterministicRendering={true}
                                    extendedState={{
                                        heightSlider: heightSlider,
                                        widthSlider: widthSlider,
                                        listSearch: this.state.listSearch,
                                    }}
                                    //   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                    //   forceNonDeterministicRendering={true}
                                    rowRenderer={(type, item, index) => {
                                        if (Platform.OS !== "web") {
                                            item = type.item;
                                            index = type.index;
                                        }

                                        return <TouchableOpacity
                                            onPress={() => {
                                                NavigationService.navigateParams(checkClick ? "ListMessageChatScreen" : "ListMessageChatScreen_Root", {
                                                    item: item,
                                                    extraData: extraData
                                                })
                                            }}
                                            style={{
                                                width: "100%",
                                                // height: moderateScale(100),
                                                //   backgroundColor: index % 2 === 0 ? "red" : "green",
                                                margin: moderateScale(6),

                                                flexDirection: 'row',
                                                //  flex: 1,
                                                alignItems: 'center',
                                                padding: moderateScale(10)


                                            }}>

                                            <Image
                                                source={item.Image && item.Image.length > 0 ? item.Image : (PathFile.image.user)}
                                                //resizeMode="stretch"
                                                style={[item.Image && item.Image.length > 0 ? {} : {tintColor: Colors.gray}, {
                                                    //   margin: moderateScale(5),
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    borderRadius: moderateScale(24),

                                                    // tintColor: Colors.blackLight

                                                }]}/>
                                            <View style={{marginHorizontal: moderateScale(6)}}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    //text={item.custname}
                                                    text={item.Name + " " + item.LastName}
                                                    type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    //text={item.ResDate}
                                                    //  text={"مجری ۱۳۷"}
                                                    text={item.Role ? item.Role : " - "}
                                                    //type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.colorDarkText,
                                                        fontSize: moderateScale(14),
                                                    }}/>
                                            </View>

                                        </TouchableOpacity>

                                    }}
                                    renderFooter={this.renderFooter.bind(this)}

                                    //application


                                    columnCount={this.state.columnCount}
                                    initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                    refreshing={this.props.showRefresh}
                                    keyExtractor={(item, index) => index.toString()}
                                    data={this.state.listSearch === null ? this.props.results : (this.state.listSearch)}


                                />
                            ) : null}

                            {/*  <FlatList
                                data={this.state.listSearch === null ? this.props.results : (this.state.listSearch)}
                                renderItem={({item, index}) => {

                                    return <TouchableOpacity
                                        onPress={() => {
                                            NavigationService.navigateParams("ListMessageChatScreen", {item: item})
                                        }}
                                        style={{
                                            width: "100%",
                                            // height: moderateScale(100),
                                            //   backgroundColor: index % 2 === 0 ? "red" : "green",
                                            margin: moderateScale(6),

                                            flexDirection: 'row',
                                            //  flex: 1,
                                            alignItems: 'center',
                                            padding: moderateScale(10)


                                        }}>

                                        <Image
                                            source={item.Image && item.Image.length > 0 ? item.Image : (PathFile.image.user)}
                                            //resizeMode="stretch"
                                            style={[item.Image && item.Image.length > 0 ? {} : {tintColor: Colors.gray}, {
                                                //   margin: moderateScale(5),
                                                width: moderateScale(48),
                                                height: moderateScale(48),
                                                borderRadius: moderateScale(24),

                                                // tintColor: Colors.blackLight

                                            }]}/>
                                        <View style={{marginHorizontal: moderateScale(6)}}>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                //text={item.custname}
                                                text={item.Name + item.LastName}
                                                type={"bold"}
                                                style={{
                                                    //  textAlign: "center",
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(14),


                                                }}/>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                //text={item.ResDate}
                                                //  text={"مجری ۱۳۷"}
                                                text={item.Roll ? item.Roll : " - "}
                                                //type={"bold"}
                                                style={{
                                                    //  textAlign: "center",
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </View>

                                    </TouchableOpacity>

                                }}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                numColumns={this.state.columnCount}
                                key={this.state.columnCount}
                            />*/}
                            {
                                this.state.isLoading || (this.props.results && this.props.results.length === 0) || this.state.loadingSearch ?
                                    <DialogLoadingCustomize
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }


                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            {
                <View
                    style={[{
                        //marginVertical: moderateScale(15),
                        height: moderateScale(30),
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row'
                    }]}>
                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                    {
                        checkIndex ?

                            <View style={{flexDirection: 'row'}}>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                        let arr = container.state.arraySelected;

                                        if (idx !== -1) {
                                            arr.splice(idx, 1)

                                            container.setState({
                                                    arraySelected: arr,
                                                    [`selectFilter${index}`]: {
                                                        value: item.name,
                                                        id: item.id,
                                                        type: item.type
                                                    },
                                                    visibleModal: '',
                                                },

                                                () => {
                                                    container.getData(1)
                                                }
                                            )
                                        }
                                        // container.setState({
                                        //         [`selectFilter${index}`]: {
                                        //             value: item.name,
                                        //             id: item.id,
                                        //             type:item.type
                                        //         },
                                        //         visibleModal: '',
                                        //     },
                                        //     () => {
                                        //         let arr = this.state.arraySelected;
                                        //         this.setState({
                                        //                 arraySelected: arr
                                        //             },
                                        //             () => {
                                        //                 container.getData(1)
                                        //             }
                                        //         )
                                        //
                                        //     }
                                        // )

                                    }}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginHorizontal:moderateScale(6)
                                    }}>
                                    <HMIcon name={"md-close"} style={{
                                        fontSize: moderateScale(20),
                                        color: '#f2f2f2'
                                    }}/>

                                </TouchableOpacity>
                            </View>
                            :
                            null


                    }
                    {
                        checkIndex ?
                            <View style={{width: moderateScale(6),}}/>

                            :
                            null
                    }
                    <TouchableOpacity
                        onPress={() => {

                            this.setState({
                                    indexFilter: index,
                                    typeFilter: item.type,
                                    ["dataSource" + index]: item.list
                                },
                                () => {
                                    //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                    this.onShow('Modal')

                                })
                        }
                        }

                        style={{alignItems: 'center', flexDirection: 'row'}}
                    >

                        <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                    style={{
                                        color: checkIndex ? Colors.white : Colors.gray,
                                        //marginHorizontal: moderateScale(6),
                                        fontSize: moderateScale(11),
                                        textAlign: 'center',

                                    }}/>
                        <HMIcon name={"ios-arrow-down"} style={{
                            fontSize: moderateScale(11),
                            color: checkIndex ? '#f2f2f2' : Colors.gray,
                            marginHorizontal: moderateScale(2),
                            marginTop: moderateScale(3)
                        }}/>
                    </TouchableOpacity>


                </View>

            }
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListUserChatScreen, `?type=${this.props.typee}&city=`, TypeGetListUserChatScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListUserChatScreen, `?type=${this.props.typee}&Condition=`, TypeGetListUserChatScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }


    SearchFilterFunction(data, text) {

        this.setState({

                loadingSearch: true,

            },
            () => {

            });

        const newData = data.filter(function (item) {
            const itemData = item.Name + " " + item.LastName;
            // let textData = null;
            //   if (i18n.locale == "en")
            const textData = text.toUpperCase();
            // else
            //  textData = text;
            return itemData.indexOf(textData) > -1
        })

        this.setState({
                listSearch: text && text.length > 0 ? newData : [],
                loadingSearch: false,

            },
            () => {
                console.log("text", text, this.state.listSearch, newData)
            })
    }
}
